import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UtilitiesService} from '../../services/utilities-service/utilities.service';

@Component({
  selector: 'app-card-assistant',
  templateUrl: './card-assistant.component.html',
  styleUrls: ['./card-assistant.component.scss']
})
export class CardAssistantComponent implements OnInit {
  @Input() disabled = false;
  @Input() selectable = true;
  @Input() erasable = false;
  @Input() active: boolean;
  @Input() name: string;
  @Input() lastName: string;
  @Input() imageProfile: string;
  @Input() gender: string;
  @Input() birthday: Date;
  @Output() selected: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() delete: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    public utilitiesService: UtilitiesService
  ) { }

  ngOnInit(): void {
  }

  /**
   * Emite al padre si la tarjeta es eliminable o solo seleccionable
   */
  onEmitSelected(): void {
    if (this.erasable) {
      this.delete.emit(true);
    } else {
      this.selected.emit(true);
    }
  }
}
